'use client';

import Link from 'next/link';
import { useAuth } from '@/lib/auth-context';

export function DeliberateNavLink() {
  const { role, isLoading } = useAuth();

  if (isLoading || role !== 'admin') {
    return null;
  }

  return (
    <Link
      href="/deliberate"
      title="Deliberate in a Sandbox"
      className="text-zinc-600 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-100 pl-3 pr-0 py-2"
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    </Link>
  );
}
